function instanceOfClass(instance: any, type: string): boolean {

    // handle undefined string number boolean object symbol
    if (typeof instance === type.toLowerCase()) {
        return true;
    }

    // covers null
    if (instance === undefined || instance === null) {
        return false;
    }

    // incase constructor.name has been mangled by jsUglify, we check `__fname` first
    const constructorName = instance.__proto__.constructor.__fname || instance.__proto__.constructor.name;

    if (constructorName === type) {
        return true;
    }

    if (constructorName === "Object") {
        return false;
    }

    return instanceOfClass(instance.__proto__, type);
}

export { instanceOfClass };
